import { useMutation } from '@tanstack/react-query';

import { createFeedback, updateFeedback } from '../../../api/feedback';
import { FeedbackForm, FeedbackResponse } from '../../../api-types/director';

export function useCreateFeedbackMutation(onSuccess?: (data: FeedbackResponse) => void) {
  return useMutation({
    mutationFn: (params: FeedbackForm) =>
      createFeedback({
        rating: params.rating,
        message: params.message,
        feedbackPath: params.feedbackPath,
      }),
    onSuccess,
  });
}

type UpdateFeedbackMutationParams = FeedbackForm & {
  feedbackId: string;
};

export function useUpdateFeedbackMutation(onSuccess?: (data: FeedbackResponse) => void) {
  return useMutation({
    mutationFn: (params: UpdateFeedbackMutationParams) =>
      updateFeedback(params.feedbackId, {
        rating: params.rating,
        message: params.message,
        feedbackPath: params.feedbackPath,
      }),
    onSuccess,
  });
}
